/* unplugin-vue-components disabled */import script from "./OrangeButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrangeButton.vue?vue&type=script&lang=ts&setup=true"

import "./OrangeButton.vue?vue&type=style&index=0&id=2106a6c6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2106a6c6"]])

export default __exports__